/*
 *
 * StylesPage reducer
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import produce from 'immer';
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons/faAngleRight';
import { faSortAmountDown } from '@fortawesome/pro-regular-svg-icons/faSortAmountDown';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { LOAD_STYLE_REQUEST, LOAD_STYLE_SUCCESS, LOAD_STYLE_FAILURE, SAVE_STYLE_REQUEST, SAVE_STYLE_SUCCESS, SAVE_STYLE_FAILURE, UPDATE_DATA, UPDATE_SWATCH, UPDATE_INPUT, UPDATE_PADDING_DATA, UPDATE_TRANSITION, UPDATE_COLOR_STYLES, UPDATE_COLOR_STYLES_NAME, UPDATE_TYPOGRAPHY_STYLES, UPDATE_TYPOGRAPHY_STYLES_NAME, } from './constants';
import { hasDrafts } from '../../utils/meta';
import { LOAD_FILES_FAILURE, LOAD_FILES_SUCCESS, } from '../ViewBuilder/constants';
import { newStyles } from './helper';
export var initialState = {
    data: {
        backgroundColor: '#ffffff',
        secondaryBackgroundColor: '#ffffff',
        primaryColor: '#36e0b7',
        secondaryColor: '#0e3951',
        topBarColor: '#ececec',
        topBarColor2: '',
        topBarGradient: false,
        topBarGradientCutoff: 1,
        topBarBackgroundImage: '',
        topBarBackgroundImageSize: '',
        topBarDrawerButtonIcon: faBars,
        topBarDrawerButtonColor: '#ffffff',
        topBarDrawerButtonBackgroundColor: '#36e0b7',
        topBarDrawerButtonBorderColor: '#ffffff',
        topBarDrawerButtonBorderWidth: 0,
        topBarDrawerButtonBorderRadius: 0,
        topBarDrawerButtonBorderLeftColor: '#ffffff',
        topBarDrawerButtonBorderLeftWidth: 0,
        topBarDrawerButtonBorderRightColor: '#ffffff',
        topBarDrawerButtonBorderRightWidth: 0,
        topBarDrawerButtonBorderTopColor: '#ffffff',
        topBarDrawerButtonBorderTopWidth: 0,
        topBarDrawerButtonBorderBottomColor: '#ffffff',
        topBarDrawerButtonBorderBottomWidth: 0,
        topBarDrawerButtonBorderStyle: 'solid',
        topBarDrawerButtonBorderTopLeftRadius: 0,
        topBarDrawerButtonBorderTopRightRadius: 0,
        topBarDrawerButtonBorderBottomLeftRadius: 0,
        topBarDrawerButtonBorderBottomRightRadius: 0,
        topBarBackButtonIcon: faAngleLeft,
        topBarBackButtonColor: '#ffffff',
        topBarBackButtonBackgroundColor: '#36e0b7',
        topBarBackButtonBorderLeftColor: '#ffffff',
        topBarBackButtonBorderLeftWidth: 0,
        topBarBackButtonBorderRightColor: '#ffffff',
        topBarBackButtonBorderRightWidth: 0,
        topBarBackButtonBorderTopColor: '#ffffff',
        topBarBackButtonBorderTopWidth: 0,
        topBarBackButtonBorderBottomColor: '#ffffff',
        topBarBackButtonBorderBottomWidth: 0,
        topBarBackButtonBorderStyle: 'solid',
        topBarBackButtonBorderTopLeftRadius: 0,
        topBarBackButtonBorderTopRightRadius: 0,
        topBarBackButtonBorderBottomLeftRadius: 0,
        topBarBackButtonBorderBottomRightRadius: 0,
        topBarPreviousButtonIcon: faAngleLeft,
        topBarPreviousButtonColor: '#ffffff',
        topBarPreviousButtonBackgroundColor: '#36e0b7',
        topBarPreviousButtonBorderLeftColor: '#ffffff',
        topBarPreviousButtonBorderLeftWidth: 0,
        topBarPreviousButtonBorderRightColor: '#ffffff',
        topBarPreviousButtonBorderRightWidth: 0,
        topBarPreviousButtonBorderTopColor: '#ffffff',
        topBarPreviousButtonBorderTopWidth: 0,
        topBarPreviousButtonBorderBottomColor: '#ffffff',
        topBarPreviousButtonBorderBottomWidth: 0,
        topBarPreviousButtonBorderStyle: 'solid',
        topBarPreviousButtonBorderTopLeftRadius: 0,
        topBarPreviousButtonBorderTopRightRadius: 0,
        topBarPreviousButtonBorderBottomLeftRadius: 0,
        topBarPreviousButtonBorderBottomRightRadius: 0,
        topBarNextButtonIcon: faAngleRight,
        topBarNextButtonColor: '#ffffff',
        topBarNextButtonBackgroundColor: '#36e0b7',
        topBarNextButtonBorderLeftColor: '#ffffff',
        topBarNextButtonBorderLeftWidth: 0,
        topBarNextButtonBorderRightColor: '#ffffff',
        topBarNextButtonBorderRightWidth: 0,
        topBarNextButtonBorderTopColor: '#ffffff',
        topBarNextButtonBorderTopWidth: 0,
        topBarNextButtonBorderBottomColor: '#ffffff',
        topBarNextButtonBorderBottomWidth: 0,
        topBarNextButtonBorderStyle: 'solid',
        topBarNextButtonBorderTopLeftRadius: 0,
        topBarNextButtonBorderTopRightRadius: 0,
        topBarNextButtonBorderBottomLeftRadius: 0,
        topBarNextButtonBorderBottomRightRadius: 0,
        topBarSortButtonIcon: faSortAmountDown,
        topBarSortButtonColor: '#ffffff',
        topBarSortButtonBackgroundColor: '#36E0B7',
        topBarSortButtonBorderLeftColor: '#ffffff',
        topBarSortButtonBorderLeftWidth: 0,
        topBarSortButtonBorderRightColor: '#ffffff',
        topBarSortButtonBorderRightWidth: 0,
        topBarSortButtonBorderTopColor: '#ffffff',
        topBarSortButtonBorderTopWidth: 0,
        topBarSortButtonBorderBottomColor: '#ffffff',
        topBarSortButtonBorderBottomWidth: 0,
        topBarSortButtonBorderStyle: 'solid',
        topBarSortButtonBorderTopLeftRadius: 0,
        topBarSortButtonBorderTopRightRadius: 0,
        topBarSortButtonBorderBottomLeftRadius: 0,
        topBarSortButtonBorderBottomRightRadius: 0,
        topBarContextButtonIcon: faEllipsisV,
        topBarContextButtonColor: '#ffffff',
        topBarContextButtonBackgroundColor: '#36E0B7',
        topBarContextButtonBorderLeftColor: '#ffffff',
        topBarContextButtonBorderLeftWidth: 0,
        topBarContextButtonBorderRightColor: '#ffffff',
        topBarContextButtonBorderRightWidth: 0,
        topBarContextButtonBorderTopColor: '#ffffff',
        topBarContextButtonBorderTopWidth: 0,
        topBarContextButtonBorderBottomColor: '#ffffff',
        topBarContextButtonBorderBottomWidth: 0,
        topBarContextButtonBorderStyle: 'solid',
        topBarContextButtonBorderTopLeftRadius: 0,
        topBarContextButtonBorderTopRightRadius: 0,
        topBarContextButtonBorderBottomLeftRadius: 0,
        topBarContextButtonBorderBottomRightRadius: 0,
        topBarAddButtonIcon: faPlus,
        topBarAddButtonColor: '#ffffff',
        topBarAddButtonBackgroundColor: '#36E0B7',
        topBarAddButtonBorderLeftColor: '#ffffff',
        topBarAddButtonBorderLeftWidth: 0,
        topBarAddButtonBorderRightColor: '#ffffff',
        topBarAddButtonBorderRightWidth: 0,
        topBarAddButtonBorderTopColor: '#ffffff',
        topBarAddButtonBorderTopWidth: 0,
        topBarAddButtonBorderBottomColor: '#ffffff',
        topBarAddButtonBorderBottomWidth: 0,
        topBarAddButtonBorderStyle: 'solid',
        topBarAddButtonBorderTopLeftRadius: 0,
        topBarAddButtonBorderTopRightRadius: 0,
        topBarAddButtonBorderBottomLeftRadius: 0,
        topBarAddButtonBorderBottomRightRadius: 0,
        topBarCarouselIndicatorBorderWidth: 0,
        topBarCarouselIndicatorBorderStyle: 'solid',
        topBarCarouselIndicatorBorderColor: '#ffffff',
        topBarCarouselIndicatorBackgroundColor: '#cccccc',
        topBarCarouselIndicatorBackgroundOpacity: 100,
        topBarCarouselIndicatorSelectedBorderWidth: 0,
        topBarCarouselIndicatorSelectedBorderStyle: 'solid',
        topBarCarouselIndicatorSelectedBorderColor: '#ffffff',
        topBarCarouselIndicatorSelectedBackgroundColor: '#cccccc',
        topBarCarouselIndicatorSelectedBackgroundOpacity: 100,
        menuBackgroundColor: '#ffffff',
        menuBackgroundColor2: '',
        menuBackgroundGradient: false,
        menuSelectedItemColor: 'transparent',
        menuBackgroundGradientCutoff: 1,
        menuBackgroundImage: '',
        menuBackgroundImageSize: '',
        subMenuBarBackgroundColor: '#ececec',
        subMenuBarBackgroundColor2: '',
        subMenuBarBackgroundGradient: false,
        subMenuBarBackgroundGradientCutoff: 1,
        subMenuBarBackgroundImage: '',
        subMenuBarBackgroundImageSize: 'cover',
        subMenuBarBackgroundPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuBarBackgroundBorderLeftColor: '#ffffff',
        subMenuBarBackgroundBorderLeftWidth: 0,
        subMenuBarBackgroundBorderRightColor: '#ffffff',
        subMenuBarBackgroundBorderRightWidth: 0,
        subMenuBarBackgroundBorderTopColor: '#ffffff',
        subMenuBarBackgroundBorderTopWidth: 0,
        subMenuBarBackgroundBorderBottomColor: '#ffffff',
        subMenuBarBackgroundBorderBottomWidth: 0,
        subMenuBarBackgroundBorderStyle: 'solid',
        subMenuBarBackgroundBorderTopLeftRadius: 0,
        subMenuBarBackgroundBorderTopRightRadius: 0,
        subMenuBarBackgroundBorderBottomLeftRadius: 0,
        subMenuBarBackgroundBorderBottomRightRadius: 0,
        subMenuButtonBackgroundColor: '#ececec',
        subMenuButtonFlexDirection: 'row',
        subMenuButtonJustifyContent: 'center',
        subMenuButtonAlignItems: 'center',
        subMenuButtonPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonBorderLeftColor: '#ffffff',
        subMenuButtonBorderLeftWidth: 0,
        subMenuButtonBorderRightColor: '#ffffff',
        subMenuButtonBorderRightWidth: 0,
        subMenuButtonBorderTopColor: '#ffffff',
        subMenuButtonBorderTopWidth: 0,
        subMenuButtonBorderBottomColor: '#ffffff',
        subMenuButtonBorderBottomWidth: 0,
        subMenuButtonBorderStyle: 'solid',
        subMenuButtonBorderTopLeftRadius: 0,
        subMenuButtonBorderTopRightRadius: 0,
        subMenuButtonBorderBottomLeftRadius: 0,
        subMenuButtonBorderBottomRightRadius: 0,
        subMenuButtonSelectedBackgroundColor: '#ececec',
        subMenuButtonSelectedFlexDirection: 'row',
        subMenuButtonSelectedJustifyContent: 'center',
        subMenuButtonSelectedAlignItems: 'center',
        subMenuButtonSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonSelectedBorderLeftColor: '#ffffff',
        subMenuButtonSelectedBorderLeftWidth: 0,
        subMenuButtonSelectedBorderRightColor: '#ffffff',
        subMenuButtonSelectedBorderRightWidth: 0,
        subMenuButtonSelectedBorderTopColor: '#ffffff',
        subMenuButtonSelectedBorderTopWidth: 0,
        subMenuButtonSelectedBorderBottomColor: '#ffffff',
        subMenuButtonSelectedBorderBottomWidth: 0,
        subMenuButtonSelectedBorderStyle: 'solid',
        subMenuButtonSelectedBorderTopLeftRadius: 0,
        subMenuButtonSelectedBorderTopRightRadius: 0,
        subMenuButtonSelectedBorderBottomLeftRadius: 0,
        subMenuButtonSelectedBorderBottomRightRadius: 0,
        subMenuButtonTextFontFamily: 'System',
        subMenuButtonTextFontWeight: 'normal',
        subMenuButtonTextFontColor: '#000000',
        subMenuButtonTextFontSize: 18,
        subMenuButtonTextFontStyle: 'normal',
        subMenuButtonTextTextDecoration: 'none',
        subMenuButtonTextTextTransform: 'none',
        subMenuButtonTextTextShadowColor: '#ffffff',
        subMenuButtonTextTextShadowRadius: 0,
        subMenuButtonTextLetterSpacing: 0,
        subMenuButtonTextNumberOfLines: 1,
        subMenuButtonTextEllipsizeMode: 'tail',
        subMenuButtonTextFlexDirection: 'row',
        subMenuButtonTextJustifyContent: 'center',
        subMenuButtonTextAlignItems: 'center',
        subMenuButtonTextPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonTextBorderLeftColor: '#ffffff',
        subMenuButtonTextBorderLeftWidth: 0,
        subMenuButtonTextBorderRightColor: '#ffffff',
        subMenuButtonTextBorderRightWidth: 0,
        subMenuButtonTextBorderTopColor: '#ffffff',
        subMenuButtonTextBorderTopWidth: 0,
        subMenuButtonTextBorderBottomColor: '#ffffff',
        subMenuButtonTextBorderBottomWidth: 0,
        subMenuButtonTextBorderStyle: 'solid',
        subMenuButtonTextBorderTopLeftRadius: 0,
        subMenuButtonTextBorderTopRightRadius: 0,
        subMenuButtonTextBorderBottomLeftRadius: 0,
        subMenuButtonTextBorderBottomRightRadius: 0,
        subMenuButtonTextSelectedFontFamily: 'System',
        subMenuButtonTextSelectedFontWeight: 'normal',
        subMenuButtonTextSelectedFontColor: '#000000',
        subMenuButtonTextSelectedFontSize: 18,
        subMenuButtonTextSelectedFontStyle: 'normal',
        subMenuButtonTextSelectedTextDecoration: 'none',
        subMenuButtonTextSelectedTextTransform: 'none',
        subMenuButtonTextSelectedTextShadowColor: '#ffffff',
        subMenuButtonTextSelectedTextShadowRadius: 0,
        subMenuButtonTextSelectedLetterSpacing: 0,
        subMenuButtonTextSelectedNumberOfLines: 1,
        subMenuButtonTextSelectedEllipsizeMode: 'tail',
        subMenuButtonTextSelectedFlexDirection: 'row',
        subMenuButtonTextSelectedJustifyContent: 'center',
        subMenuButtonTextSelectedAlignItems: 'center',
        subMenuButtonTextSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        subMenuButtonTextSelectedBorderLeftColor: '#ffffff',
        subMenuButtonTextSelectedBorderLeftWidth: 0,
        subMenuButtonTextSelectedBorderRightColor: '#ffffff',
        subMenuButtonTextSelectedBorderRightWidth: 0,
        subMenuButtonTextSelectedBorderTopColor: '#ffffff',
        subMenuButtonTextSelectedBorderTopWidth: 0,
        subMenuButtonTextSelectedBorderBottomColor: '#ffffff',
        subMenuButtonTextSelectedBorderBottomWidth: 0,
        subMenuButtonTextSelectedBorderStyle: 'solid',
        subMenuButtonTextSelectedBorderTopLeftRadius: 0,
        subMenuButtonTextSelectedBorderTopRightRadius: 0,
        subMenuButtonTextSelectedBorderBottomLeftRadius: 0,
        subMenuButtonTextSelectedBorderBottomRightRadius: 0,
        tabBarBackgroundColor: '#ececec',
        tabBarBackgroundColor2: '',
        tabBarBackgroundGradient: false,
        tabBarBackgroundGradientCutoff: 1,
        tabBarBackgroundImage: '',
        tabBarBackgroundImageSize: 'cover',
        tabBarBackgroundPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabBarBackgroundBorderLeftColor: '#ffffff',
        tabBarBackgroundBorderLeftWidth: 0,
        tabBarBackgroundBorderRightColor: '#ffffff',
        tabBarBackgroundBorderRightWidth: 0,
        tabBarBackgroundBorderTopColor: '#ffffff',
        tabBarBackgroundBorderTopWidth: 0,
        tabBarBackgroundBorderBottomColor: '#ffffff',
        tabBarBackgroundBorderBottomWidth: 0,
        tabBarBackgroundBorderStyle: 'solid',
        tabBarBackgroundBorderTopLeftRadius: 0,
        tabBarBackgroundBorderTopRightRadius: 0,
        tabBarBackgroundBorderBottomLeftRadius: 0,
        tabBarBackgroundBorderBottomRightRadius: 0,
        tabButtonBackgroundColor: '#ececec',
        tabButtonFlexDirection: 'row',
        tabButtonJustifyContent: 'center',
        tabButtonAlignItems: 'center',
        tabButtonPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonBorderLeftColor: '#ffffff',
        tabButtonBorderLeftWidth: 0,
        tabButtonBorderRightColor: '#ffffff',
        tabButtonBorderRightWidth: 0,
        tabButtonBorderTopColor: '#ffffff',
        tabButtonBorderTopWidth: 0,
        tabButtonBorderBottomColor: '#ffffff',
        tabButtonBorderBottomWidth: 0,
        tabButtonBorderStyle: 'solid',
        tabButtonBorderTopLeftRadius: 0,
        tabButtonBorderTopRightRadius: 0,
        tabButtonBorderBottomLeftRadius: 0,
        tabButtonBorderBottomRightRadius: 0,
        tabButtonSelectedBackgroundColor: '#ececec',
        tabButtonSelectedFlexDirection: 'row',
        tabButtonSelectedJustifyContent: 'center',
        tabButtonSelectedAlignItems: 'center',
        tabButtonSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonSelectedBorderLeftColor: '#ffffff',
        tabButtonSelectedBorderLeftWidth: 0,
        tabButtonSelectedBorderRightColor: '#ffffff',
        tabButtonSelectedBorderRightWidth: 0,
        tabButtonSelectedBorderTopColor: '#ffffff',
        tabButtonSelectedBorderTopWidth: 0,
        tabButtonSelectedBorderBottomColor: '#ffffff',
        tabButtonSelectedBorderBottomWidth: 0,
        tabButtonSelectedBorderStyle: 'solid',
        tabButtonSelectedBorderTopLeftRadius: 0,
        tabButtonSelectedBorderTopRightRadius: 0,
        tabButtonSelectedBorderBottomLeftRadius: 0,
        tabButtonSelectedBorderBottomRightRadius: 0,
        tabButtonTextFontFamily: 'System',
        tabButtonTextFontWeight: 'normal',
        tabButtonTextFontColor: '#000000',
        tabButtonTextFontSize: 18,
        tabButtonTextFontStyle: 'normal',
        tabButtonTextTextDecoration: 'none',
        tabButtonTextTextTransform: 'none',
        tabButtonTextTextShadowColor: '#ffffff',
        tabButtonTextTextShadowRadius: 0,
        tabButtonTextLetterSpacing: 0,
        tabButtonTextNumberOfLines: 1,
        tabButtonTextEllipsizeMode: 'tail',
        tabButtonTextFlexDirection: 'row',
        tabButtonTextJustifyContent: 'center',
        tabButtonTextAlignItems: 'center',
        tabButtonTextPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonTextBorderLeftColor: '#ffffff',
        tabButtonTextBorderLeftWidth: 0,
        tabButtonTextBorderRightColor: '#ffffff',
        tabButtonTextBorderRightWidth: 0,
        tabButtonTextBorderTopColor: '#ffffff',
        tabButtonTextBorderTopWidth: 0,
        tabButtonTextBorderBottomColor: '#ffffff',
        tabButtonTextBorderBottomWidth: 0,
        tabButtonTextBorderStyle: 'solid',
        tabButtonTextBorderTopLeftRadius: 0,
        tabButtonTextBorderTopRightRadius: 0,
        tabButtonTextBorderBottomLeftRadius: 0,
        tabButtonTextBorderBottomRightRadius: 0,
        tabButtonTextSelectedFontFamily: 'System',
        tabButtonTextSelectedFontWeight: 'normal',
        tabButtonTextSelectedFontColor: '#000000',
        tabButtonTextSelectedFontSize: 18,
        tabButtonTextSelectedFontStyle: 'normal',
        tabButtonTextSelectedTextDecoration: 'none',
        tabButtonTextSelectedTextTransform: 'none',
        tabButtonTextSelectedTextShadowColor: '#ffffff',
        tabButtonTextSelectedTextShadowRadius: 0,
        tabButtonTextSelectedLetterSpacing: 0,
        tabButtonTextSelectedNumberOfLines: 1,
        tabButtonTextSelectedEllipsizeMode: 'tail',
        tabButtonTextSelectedFlexDirection: 'row',
        tabButtonTextSelectedJustifyContent: 'center',
        tabButtonTextSelectedAlignItems: 'center',
        tabButtonTextSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonTextSelectedBorderLeftColor: '#ffffff',
        tabButtonTextSelectedBorderLeftWidth: 0,
        tabButtonTextSelectedBorderRightColor: '#ffffff',
        tabButtonTextSelectedBorderRightWidth: 0,
        tabButtonTextSelectedBorderTopColor: '#ffffff',
        tabButtonTextSelectedBorderTopWidth: 0,
        tabButtonTextSelectedBorderBottomColor: '#ffffff',
        tabButtonTextSelectedBorderBottomWidth: 0,
        tabButtonTextSelectedBorderStyle: 'solid',
        tabButtonTextSelectedBorderTopLeftRadius: 0,
        tabButtonTextSelectedBorderTopRightRadius: 0,
        tabButtonTextSelectedBorderBottomLeftRadius: 0,
        tabButtonTextSelectedBorderBottomRightRadius: 0,
        tabButtonIconColor: '#ffffff',
        tabButtonIconPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        tabButtonIconSelectedColor: '#ffffff',
        tabButtonIconSelectedPaddings: {
            paddingTop: 0,
            paddingLeft: 0,
            paddingRight: 0,
            paddingBottom: 0,
        },
        calendarBackground: '#ffffff',
        calendarTextSectionTitleColor: '#b6c1cd',
        calendarSelectedDayBackgroundColor: '#36e0b7',
        calendarSelectedDayTextColor: '#000000',
        calendarTodayTextColor: '#000000',
        calendarDayTextColor: '#2d4150',
        calendarTextDisabledColor: '#d9e1e8',
        calendarMonthTextColor: '#2d4150',
        calendarTextDayFontFamily: 'System',
        calendarTextDayFontSize: 16,
        calendarTextDayFontWeight: '300',
        calendarTextMonthFontFamily: 'System',
        calendarTextMonthFontWeight: 'bold',
        calendarTextMonthFontSize: 16,
        calendarTextDayHeaderFontFamily: 'System',
        calendarTextDayHeaderFontWeight: '300',
        calendarTextDayHeaderFontSize: 16,
        calendarMonthNextButtonIcon: faAngleRight,
        calendarMonthNextButtonIconColor: '#000000',
        calendarMonthPreviousButtonIcon: faAngleLeft,
        calendarMonthPreviousButtonIconColor: '#000000',
        supportingColor1: '#619863',
        supportingColor2: '#13958e',
        supportingColor3: '#eeeeee',
        searchBarColor: 'transparent',
        searchBackgroundColor: 'transparent',
        headerFontFamily: 'System',
        headerFontWeight: 'bold',
        headerFontColor: '#000000',
        headerFontSize: 18,
        headerFontStyle: 'normal',
        headerTextDecoration: 'none',
        headerTextTransform: 'none',
        headerTextShadowColor: 'transparent',
        headerTextShadowRadius: 0,
        headerLetterSpacing: 0,
        headerNumberOfLines: 1,
        headerEllipsizeMode: 'clip',
        menuFontFamily: 'System',
        menuFontWeight: 'bold',
        menuFontColor: '#000000',
        menuFontSize: 18,
        menuFontStyle: 'normal',
        menuTextDecoration: 'none',
        menuTextTransform: 'none',
        menuTextShadowColor: 'transparent',
        menuTextShadowRadius: 0,
        menuLetterSpacing: 0,
        menuNumberOfLines: 1,
        menuEllipsizeMode: 'clip',
        bodyFontFamily: 'System',
        bodyFontWeight: 'normal',
        bodyFontColor: '#222222',
        bodyFontSize: 14,
        bodyFontStyle: 'normal',
        bodyTextDecoration: 'none',
        bodyTextTransform: 'none',
        bodyTextShadowColor: 'transparent',
        bodyTextShadowRadius: 0,
        bodyLetterSpacing: 0,
        bodyNumberOfLines: 1,
        bodyEllipsizeMode: 'clip',
        borderLeftColor: '#cccccc',
        borderLeftWidth: 1,
        borderRightColor: '#cccccc',
        borderRightWidth: 1,
        borderTopColor: '#cccccc',
        borderTopWidth: 1,
        borderBottomColor: '#cccccc',
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        paddings: {
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
        },
        transition: {
            type: 'none',
            duration: '250',
        },
        drawerShadow: false,
        swatches: [
            '#000000',
            '#ffffff',
            '#ff0000',
            '#00ff00',
            '#0000ff',
            '#36e0b7',
            '#0e3951',
            '#ff00ff',
            '#00ffff',
            '#f0f0f0',
        ],
        colorStyles: [
            { id: 'color:1', name: 'Primary', value: '#0FC08D' },
            { id: 'color:2', name: 'Primary Shade', value: '#0B906A' },
            { id: 'color:3', name: 'Secondary', value: '#0F96C0' },
            { id: 'color:4', name: 'Secondary Shade', value: '#0B7190' },
            { id: 'color:5', name: 'Background', value: '#F8F8FB' },
            { id: 'color:6', name: 'Text', value: '#252525' },
            { id: 'color:7', name: 'Subtext', value: '#696969' },
            { id: 'color:8', name: 'Info', value: '#7496EB' },
            { id: 'color:9', name: 'Warning', value: '#FF9966' },
            { id: 'color:10', name: 'Error', value: '#FF6666' },
        ],
        textStyles: [
            {
                id: 'text:1',
                name: 'Title 1',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 24,
                    fontWeight: '700',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:2',
                name: 'Title 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 24,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:3',
                name: 'Title 3',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 22,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:4',
                name: 'Title 4',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 22,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:5',
                name: 'Subtitle 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:6',
                name: 'Subtitle 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:7',
                name: 'Body Text 1',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 18,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:8',
                name: 'Body Text 2',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 16,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:9',
                name: 'Button Text',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 16,
                    fontWeight: '600',
                    letterSpacing: 0,
                },
            },
            {
                id: 'text:10',
                name: 'Subtext',
                values: {
                    fontFamily: 'Open Sans',
                    fontSize: 12,
                    fontWeight: '400',
                    letterSpacing: 0,
                },
            },
        ],
    },
    name: '',
    description: '',
    loading: false,
    error: false,
    saving: false,
    errorSaving: false,
    isDraft: false,
    meta: {},
    icons: [],
};
function stylesPageReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        var _a;
        switch (action.type) {
            case LOAD_STYLE_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_STYLE_SUCCESS:
                state.data = ((_a = action.style.data) === null || _a === void 0 ? void 0 : _a.colorStyles)
                    ? action.style.data
                    : __assign(__assign(__assign({}, initialState.data), action.style.data), newStyles);
                state.meta = action.meta;
                state.name = action.style.name;
                state.description = action.style.description;
                state.isDraft = hasDrafts(action.meta);
                state.loading = false;
                state.error = false;
                break;
            case LOAD_STYLE_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case SAVE_STYLE_REQUEST:
                state.saving = true;
                state.errorSaving = false;
                break;
            case SAVE_STYLE_SUCCESS:
                state.saving = false;
                state.errorSaving = false;
                break;
            case SAVE_STYLE_FAILURE:
                state.saving = false;
                state.errorSaving = action.err;
                break;
            case LOAD_FILES_SUCCESS:
                state.icons = action.icons;
                state.loading = false;
                state.error = false;
                break;
            case LOAD_FILES_FAILURE:
                state.loading = false;
                state.error = action.err;
                break;
            case UPDATE_DATA:
                state.data[action.field] = action.value;
                break;
            case UPDATE_PADDING_DATA:
                state.data[action.paddingField][action.field] = action.value;
                break;
            case UPDATE_TRANSITION:
                state.data.transition[action.field] = action.value;
                break;
            case UPDATE_SWATCH:
                state.data.swatches[action.index] = action.value;
                break;
            case UPDATE_INPUT:
                state[action.field] = action.value;
                break;
            case UPDATE_COLOR_STYLES:
                state.data.colorStyles[action.index].value = action.value;
                break;
            case UPDATE_COLOR_STYLES_NAME:
                state.data.colorStyles[action.index].name = action.name;
                break;
            case UPDATE_TYPOGRAPHY_STYLES:
                state.data.textStyles[action.index].values = action.value;
                break;
            case UPDATE_TYPOGRAPHY_STYLES_NAME:
                state.data.textStyles[action.index].name = action.name;
                break;
            default:
                break;
        }
    });
}
export default stylesPageReducer;
